import color from 'color';

export const COLOR_BLACK = '#110729';
export const COLOR_WHITE = '#ffffff';
export const COLOR_RED = '#ff6464';
export const COLOR_RED_TRANSPARENT = color(COLOR_RED).fade(0.33).string();
export const COLOR_RED_DEEP = '#dd4444';
export const COLOR_GREEN = '#23b46a';
export const COLOR_GREEN_TRANSPARENT = color(COLOR_GREEN).fade(0.33).string();
export const COLOR_YELLOW = '#f2b45b';
export const COLOR_STRONG_YELLOW = '#d9ff00ff';
export const COLOR_TRANSP_YELLOW_HIGHLIGHT = color(COLOR_YELLOW).fade(0.62).string();
export const COLOR_PRIMARY = '#32376C';
export const COLOR_VIOLET_DARKEST = '#322159';
export const COLOR_VIOLET_DARKER = '#453271';
export const COLOR_VIOLET_PRIMARY = '#5f4b8b';
export const COLOR_DEEP_BLUE = '#00558c';
export const COLOR_TAB_WHITE = '#E9E6EF';
export const COLOR_BLUE_LINK = '#1a91ab';
export const COLOR_BLUE_PRIMARY = '#2acaed';
export const COLOR_BLUE_NEON = '#09edf5';
export const COLOR_BLUE_NEON_LUMINATING = '#00f6ff';
export const COLOR_GREY_TEXT = '#737373';
export const COLOR_GREY_DARKER = '#cbcbcb';
export const COLOR_GREY_LIGHT = '#e5e5e5';
export const COLOR_GREY_BACKGROUND = '#f8f8f8';
export const COLOR_TRANSP_VIOLET = color('#5f4b8b').fade(0.92).string();
export const COLOR_GREY_LIGHTER = '#ebebeb';
export const COLOR_ICON_BACKGROUND = '#f1eff6';
export const COLOR_TRANSP_GREY_LIGHT = color(COLOR_GREY_LIGHTER).fade(0.35).string();
export const COLOR_TRANSP_BLUE_DARKER = color(COLOR_BLUE_NEON).fade(0.68).string();
export const COLOR_TRANSP_BLUE = color(COLOR_BLUE_NEON).fade(0.88).string();
export const COLOR_TRANSP_BLUE_DISABLED = color(COLOR_BLUE_PRIMARY).fade(0.8).string();

// Semantic surface / text tokens (dark-mode safe)
export const COLOR_TEXT_HEADING = '#2A2353';
export const COLOR_TEXT_MUTED_PURPLE = '#8A83A8';
export const COLOR_TEXT_SUBTLE_PURPLE = '#667799';
export const COLOR_SURFACE_ELEVATED = '#FCFCFF';
export const COLOR_SURFACE_PAGE = '#F5F6F8';
export const COLOR_SURFACE_ALT = '#f7f7f7';
export const COLOR_BORDER_SUBTLE = '#e6e6e6';
export const COLOR_ERROR_BG = '#FEE2E2';
export const COLOR_ERROR_TEXT_DARK = '#B42318';
export const COLOR_INDIGO_PRIMARY = '#4F46A5';
export const COLOR_TEAL_ACCENT = '#13c2c2';
export const COLOR_TREE_NODE_BG = '#24164a';
export const COLOR_TREE_NODE_ACCENT = '#7c3aed';

export const SPACING_BASE = 4;

export const RADIUS = 4;

export type PointerVariant = 'fine' | 'coarse';

// Dual-threshold breakpoints: each layout switch happens at a lower width for
// fine pointers (mouse/trackpad — a PC window can be used at full density even
// when narrow) and at a higher width for coarse pointers (touch — needs the
// compact/touch layout earlier).
export const BREAKPOINTS = {
    mobile: { fine: 599, coarse: 767 },
    tablet: { fine: 899, coarse: 1023 },
    // desktop.fine 1091: a 1366×768 laptop at 125% OS scaling has a 1092px CSS
    // viewport and must get the full desktop view with a mouse.
    // desktop.coarse 1279: a Full HD device at 150% scaling has a 1280px CSS
    // viewport and must still get the desktop view.
    desktop: { fine: 1091, coarse: 1279 },
    wide: { fine: 1440, coarse: 1440 },
} as const;

if (process.env.NODE_ENV !== 'production') {
    (Object.entries(BREAKPOINTS) as [string, { fine: number, coarse: number }][])
        .forEach(([name, { fine, coarse }]) => {
            if (fine > coarse) {
                throw new Error(`BREAKPOINTS.${name}: fine (${fine}) must be <= coarse (${coarse})`);
            }
        });
}

export const MIN_TOUCH_TARGET = 44;

export const FONT_PRIMARY = 'Nunito Sans';
export const FONT_SECONDARY = 'Electrolize';
